<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
    <rect fill="none" height="256" width="256" />
    <circle
      cx="128"
      cy="128"
      fill="none"
      r="96"
      stroke="#000"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="16"
    />
    <circle cx="128" cy="180" r="12" />
    <path
      d="M128,144v-8a28,28,0,1,0-28-28"
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="16"
    />
  </svg>
</template>
